import { DatePipe } from "@angular/common";
import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MachineRequestType } from "@enums/machineRequestType.enum";
import { ProductionStatus } from "@enums/productionStatus.enum";
import { environment } from "@environments/environment";
import { GetProductionStatusColor } from "@helpers/getProductionStatusColor";
import { GetProductionStatusColorByNumber } from "@helpers/getProductionStatusColorByNumber";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { Allocation } from "@interfaces/allocation.interface";
import { CloseSupervisorRequest } from "@interfaces/closeSupervisorRequest.interface";
import { CreateAllocationWorkOrder } from "@interfaces/createAllocationWorkOrder.interface";
import { FirewallLog } from "@interfaces/models/firewallLog.interface";
import { FirewallLogFailureReason } from "@interfaces/models/firewallLogFailureReason.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { Part } from "@interfaces/models/part.interface";
import { SupervisorRequestReason } from "@interfaces/models/supervisorRequestReason.interface";
import { WorkOrderStage } from "@interfaces/models/workOrderStage.interface";
import { WorkOrder } from "@interfaces/workOrder.interface";
import { AllocationService } from "@services/allocation.service";
import { AllocationWorkOrderService } from "@services/allocationWorkOrder.service";
import { AppSettingsService } from "@services/appSettings.service";
import { AuthService } from "@services/auth.service";
import { EdiOrderService } from "@services/ediOrder.service";
import { FileService } from "@services/file.service";
import { FirewallLogService } from "@services/firewallLog.service";
import { FirewallLogFailureReasonService } from "@services/firewallLogFailureReason.service";
import { InterfaceDeviceService } from "@services/interfaceDevice.service";
import { MachineService } from "@services/machine.service";
import { SupervisorRequestReasonService } from "@services/supervisorRequestReason.service";
import { WorkOrderService } from "@services/workOrder.service";
import { WorkOrderStageService } from "@services/workOrderStage.service";
import { BarcodeFormat } from "@zxing/library";
import { ZXingScannerComponent } from "@zxing/ngx-scanner";
import notify from "devextreme/ui/notify";
import { Guid } from "guid-typescript";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "firewall",
	styleUrls: ["firewall.css"],
	templateUrl: "firewall.html"
})
export class FirewallComponent {
	allocationQty = 0;
	allocationWo = "";
	allowedFormats = BarcodeFormat.QR_CODE;
	areasOfIssue: any[] = [];
	availableDevices: MediaDeviceInfo[] = [];
	availableStages: WorkOrderStage[] = [];
	capturedImageFile: File | null = null;
	capturedImagePreview = "";
	checkWorkOrderAllocations: any[] = [];
	checkWorkOrderDetails: any = null;
	checkWorkOrderLoading = false;
	clientName = "";
	closeSupervisorRequestDto: CloseSupervisorRequest = new CloseSupervisorRequest();
	companyName = "";
	copyright = "";
	currentStatus = ProductionStatus.Idle;
	currentStatusColor = "";
	currentStatusText = "Idle";
	firewallLogs: FirewallLog[] = [];
	firewallNokCount = 0;
	firewallOkCount = 0;
	hasCameras = false;
	hasPermission = false;
	interfaceDeviceId = 0;
	isImageModalOpen = false;
	isLoading = false;
	machine = new Machine();
	machineId = 0;
	machineRequestTypes: any;
	machines: any[] = [];
	readonly maxPinLength = 8;
	readonly minPinLength = 4;
	nokReasons: FirewallLogFailureReason[] = [];
	openSupervisorRequestId?: number;
	operatorName = "";
	orderCurrent: any = undefined;
	ordersToday: any[] = [];
	part = new Part();
	partImage = "";
	pendingLog: FirewallLog | null = null;
	pinError = "";
	pinSlots = Array(8).fill(0);
	processName = "";
	profileId = 0;
	quantityComplete = 0;
	quantityEntered = 0;
	quantityNok = 0;
	quantityPicked = 0;
	quantityRequired = 0;
	runningStages: WorkOrderStage[] = [];
	scannedResult: any;
	scanner: ZXingScannerComponent = new ZXingScannerComponent();
	scannerEnabled = true;
	selectedArea = "";
	selectedDevice: any;
	selectedMachineRequestType = MachineRequestType.Stillage;
	selectedPaint = false;
	selectedProduction = false;
	selectedReason?: number;
	selectedSupervisorRequestReasonId = 1;
	showAllocate = false;
	showChangeOrderModal = false;
	showCheckWorkOrderModal = false;
	showCheckWorkOrderScan = false;
	showCloseSupervisorRequestForm = false;
	showCloseSupervisorRequestFormLogin = false;
	showComplete = false;
	showFirewall = false;
	showImageCapture = false;
	showImagePrompt = false;
	showMode = false;
	showNok = false;
	showOpenMachineRequestForm = false;
	showOpenSupervisorRequestForm = false;
	showPopup = false;
	showScan = false;
	showSuperLogin = false;
	showSupervisor = false;
	stageId = 0;
	stageNumber = "";
	statuses: any[] = [];
	supervisorPin = "";
	supervisorRequestReasons: SupervisorRequestReason[] = [];
	totalNok = 0;
	totalOk = 0;
	workOrder: WorkOrder = new WorkOrder;
	workOrderId = 0;
	workStation: any;

	constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService, private workOrderService: WorkOrderService, private workOrderStageService: WorkOrderStageService, private machineService: MachineService, private appSettingsService: AppSettingsService, private firewallLogService: FirewallLogService, private fileService: FileService, private allocationService: AllocationService, private allocatiionWorkOrderService: AllocationWorkOrderService, private interfaceService: InterfaceDeviceService, private ediOrderService: EdiOrderService, private supervisorRequestReasonService: SupervisorRequestReasonService, private firewallLogFailureReasonService: FirewallLogFailureReasonService) {
		this.getCameras();
		this.getFailureReasons();
		this.getSupervisorRequestReasons();
		this.machineRequestTypes = GetPropertiesFromEnum(MachineRequestType);
		this.statuses = GetPropertiesFromEnum(ProductionStatus);
		this.areasOfIssue = [
			"CAD Issue",
			"Health and Safety",
			"Issue Found at Customer",
			"Maintenance Issue",
			"Person / Training Issue",
			"Process wrong",
			"Process - Assembly",
			"Process - 5 Axis Issue",
			"Process - Flat Laser issue",
			"Process - Goods-In",
			"Process - Press Issue",
			"Process - Press Brake issue",
			"Process - Weld Issue",
			"Process - Spot Weld Issue",
			"Process - Kingsland Issue",
			"Process - Fab/Deburr Issue",
			"Process - Firewall Issue",
			"Process - Logistics issue",
			"Process - Quality Issue",
			"Process - Toolroom",
			"Supplier - Material Issue",
			"Supplier - Outsource Issue",
		];
		this.currentStatusColor = GetProductionStatusColor(ProductionStatus.Idle);
		this.route.params
			.subscribe((params) => {
				this.interfaceDeviceId = Number.parseInt(params.id);
				this.getInterface();
				this.isLoading = true;
				this.showPopup = true;
				// this.getData();
				setTimeout(() => {
					this.isLoading = false;
					this.showPopup = false;
				}, 3000);
			});
	}

	assignToAllocations(workOrder: string, qty: number) {
		if (qty > 0) {
			if (workOrder == "") {
				notify("No Work Order Id Provided!", "error", 5000);
				return false;
			} else {
				const createLink = new CreateAllocationWorkOrder();
				createLink.allocationId = this.orderCurrent.allocationId;
				createLink.workOrderId = workOrder;
				createLink.quantity = qty;
				this.allocatiionWorkOrderService.app_CreateForWorkOrder(createLink)
					.subscribe(
						() => {
							notify("Work Order Allocated", "success", 5000);
							this.quantityPicked = Number.parseInt(this.quantityPicked.toString()) + Number.parseInt(qty.toString());
							this.toggleAllocate();
							this.toggleComplete();
						},
						(err) => {
							console.log(err);
							notify(err.error.response.error, "error", 5000);
						}
					);
				return false;
			}
		} else {
			notify("Quantity must be more than 0!", "error", 5000);
			return false;
		}
	}

	cameraFound(e: any) {
		console.log(e);
		this.availableDevices = e;
		this.selectedDevice = e[0];
		this.hasCameras = true;
		this.hasPermission = true;
		console.log("Devices: ", this.availableDevices);

		// selects the devices's back camera by default'
		for (const device of e) {
			if (/back|rear|environment/gi.test(device.label)) {
				new this.scanner.deviceChange(true);
				this.selectedDevice = device;
				break;
			} else if (e.length == 1) {
				new this.scanner.deviceChange(true);
				this.selectedDevice = device;
				break;
			}
		}
	}

	camerasNotFound() {
		// Display an alert modal here
		notify("No Camera Detected!", "error", 5000);
	}

	canSubmitPin(): boolean {
		return this.supervisorPin.length >= this.minPinLength;
	}

	cancelCloseSupervisorRequest() {
		this.showPopup = false;
		this.showCloseSupervisorRequestForm = false;
		this.showCloseSupervisorRequestFormLogin = false;
		this.closeSupervisorRequestDto = new CloseSupervisorRequest();
		this.supervisorPin = "";
		this.pinError = "";
	}

	cancelMachineRequest() {
		this.showPopup = false;
		this.showOpenMachineRequestForm = false;
	}

	cancelNok() {
		this.showNok = false;
		this.showPopup = false;
		this.selectedArea = "";
		this.selectedReason = undefined;
		this.selectedProduction = false;
		this.selectedPaint = false;
	}

	cancelSupervisorRequest() {
		this.showPopup = false;
		this.showOpenSupervisorRequestForm = false;
	}

	changeMode(status: ProductionStatus) {
		this.submitProductionMode(status);
		this.toggleMode();
	}

	closeChangeOrderModal() {
		this.showChangeOrderModal = false;
		this.showPopup = false;
	}

	closeCheckWorkOrderModal() {
		this.showCheckWorkOrderModal = false;
		this.showPopup = false;
		this.checkWorkOrderDetails = null;
		this.checkWorkOrderAllocations = [];
	}

	closeCheckWorkOrderScan() {
		this.showCheckWorkOrderScan = false;
		this.showPopup = false;
	}

	closeSupervisor() {
		this.showSupervisor = false;
		this.showPopup = false;
	}

	closeSupervisorRequest() {
		if (this.openSupervisorRequestId === null || this.openSupervisorRequestId === undefined) {
			return;
		}

		this.closeSupervisorRequestDto = new CloseSupervisorRequest();
		this.closeSupervisorRequestDto.supervisorRequestId = this.openSupervisorRequestId;

		this.supervisorPin = "";

		this.showPopup = true;
		this.showCloseSupervisorRequestFormLogin = true;
	}

	createAllocationForEdiOrder(id: number) {
		// if (confirm("Create allocation for this Edi Order? This can be assigned work orders later.") === false) {
		// 	return false;
		// }

		// Do the actual creation here		
		this.allocationService.app_createForEdiOrder(id)
			.subscribe(
				() => {
					notify("Allocation Created", "success", 5000);
					this.reloadPage();
				},
				(err) => {
					console.log(err);
					notify("Something went wrong!", "error", 5000);
				},
			);
		return false;
	}

	formatDate(dt: Date) {
		const datepipe: DatePipe = new DatePipe("en-GB");
		const formattedDate = datepipe.transform(dt, "dd/MM/YYYY");
		return formattedDate;
	}

	getAllocation() {
		this.allocationService.app_getById(this.orderCurrent.allocationId)
			.subscribe(
				(res: any) => {
					const allo: Allocation = res.response;
					this.quantityPicked = allo.totalAssigned;
					console.log("Current Status " + this.currentStatus);
					console.log("Current Id " + this.orderCurrent.id);
					console.log("Operator Id " + this.orderCurrent.operatorId);
					console.log("Allocation Id " + this.orderCurrent.allocationId);
					console.log("Ordered " + this.orderCurrent.quantityOrdered);
					console.log("Picked " + this.quantityPicked);
					console.log("Part ID " + this.orderCurrent.partId);
					console.log("Client ID: " + this.orderCurrent.clientId);
					console.log("Project ID: " + this.orderCurrent.part.projectId);
				},
				(err) => {
					console.log(err);
					notify("Something Went Wrong!", "Error", 5000);
				}
			);
	}

	getCameras() {
		console.log("Hit!");
	}

	getCheckWorkOrderQtyAvailable(): number {
		if (!this.checkWorkOrderDetails) return 0;
		const total = this.checkWorkOrderAllocations.reduce((sum: number, a: any) => sum + (a.quantity || 0), 0);
		return (this.checkWorkOrderDetails.quantity || 0) - total;
	}

	getCheckWorkOrderStatusBar(): { color: string; text: string } {
		const qtyAvailable = this.getCheckWorkOrderQtyAvailable();
		if (qtyAvailable <= 0) {
			return { color: "#dc2626", text: "WORK ORDER USED" };
		}
		if (this.checkWorkOrderDetails?.workOrderComplete) {
			return { color: "#16a34a", text: "WORK ORDER COMPLETED" };
		}
		return { color: "#f97316", text: "WORK ORDER IN PROGRESS" };
	}

	getData(id: number) {
		// this.orderCurrent = undefined;
		this.ordersToday = [];
		this.operatorName = "";
		this.quantityComplete = 0;
		this.quantityEntered = 0;
		this.quantityPicked = 0;
		this.quantityRequired = 0;
		console.log(id);
		this.machineService.app_OpsPlannerFirewallOrders()
			.subscribe(
				(res: any) => {
					if (res.response.length > 1) {
						this.machines = res.response;
						this.workStation = this.machines.find(x => x.machineId === id);
						this.ordersToday = this.workStation.firewallOrders;
						if (this.ordersToday.length > 0) {
							if (this.orderCurrent != undefined && this.orderCurrent != null) {
								console.log("Existing order picked");
								console.log(this.orderCurrent);
								this.setCurrentOrder(this.orderCurrent.id, this.orderCurrent.type);
							}
							else
							{
								this.setCurrentOrder(0, 0);
							}
						}
						else
						{
							this.orderCurrent = undefined;
						}

						console.log("Today");
						console.log(this.ordersToday);

						this.machine = this.machines.find(x => x.machineId === id);
						this.openSupervisorRequestId = this.workStation.openSupervisorRequestId;
						this.currentStatus = this.machine.productionStatus;
						const statuses = GetPropertiesFromEnum(ProductionStatus);
						this.currentStatusText = statuses.filter(x => x.id == this.machine.productionStatus)[0].name;
						this.currentStatusColor = this.renderStatusColor();
					}
				},
				(err) => {
					console.log(err);
					notify("Something Went Wrong!", "Error", 5000);
				}
			);
	}

	getEnvironmentProperty(property: string) {
		// @ts-ignore // Required to get around having to iterate through the object
		return environment["build"][property];
	}

	getFailureReasons() {
		this.firewallLogFailureReasonService.app_allActive()
			.subscribe(
				(res: any) => {
					this.nokReasons = res.response;
					this.nokReasons.sort((a,b) => a.reason.localeCompare(b.reason));
				},
				(err) => console.log(err)
			);
	}

	getInterface() {
		this.interfaceService.app_InterfaceById(this.interfaceDeviceId)
			.subscribe(
				(res: any) => {
					console.log(res);
					this.machineId = res.response.machineId;
					this.getData(res.response.machineId);
				},
				(err) => {
					console.log(err);
					notify("Something Went Wrong!", "Error", 5000);
				}
			);
	}

	getOrderDateValue(): string {
		if (!this.orderCurrent) {
			return "TBC";
		}

		const sourceDate = this.orderCurrent.dateRequired;

		if (!sourceDate) {
			return "TBC";
		}

		const parsed = new Date(sourceDate);
		return Number.isNaN(parsed.getTime()) ? "TBC" : parsed.toLocaleDateString("en-GB");
	}

	getSupervisorRequestReasons() {
		this.supervisorRequestReasonService.app_allActive()
			.subscribe(
				(res: any) => {
					this.supervisorRequestReasons = res.response;
				},
				(err: any) => {
					console.log(err);
					notify("Something Went Wrong!", "Error", 5000);
				}
			);
	}

	getWo(scannedResult: any) {
		this.workOrderService.app_GetByLookup(scannedResult)
			.subscribe(
				(res: any) => {
					console.log(res);
					this.workOrder = res.response;
					this.allocationWo = res.response.id;

					notify("Work Order Loaded Successfully", "Success", 5000);
				},
				(err) => {
					console.log(err);
					notify("Something Went Wrong!", "Error", 5000);
				}
			);
	}

	increaseScrap() {
		this.workOrderStageService.increaseScrapAmount(this.availableStages[0].id, this.quantityNok)
			.subscribe(
				() => {
					// notify("Stage Paused due to incomplete quantity", "success", 5000);
					this.reloadPage();
				},
				(err) => {
					notify("Something went wrong!", "error", 5000);
					console.log(err);
				}
			);
	}

	onCheckWoScanSuccess(result: string) {
		this.showCheckWorkOrderScan = false;
		this.checkWorkOrderLoading = true;
		this.workOrderService.app_GetByLookup(Guid.parse(result))
			.subscribe(
				(res: any) => {
					this.checkWorkOrderDetails = res.response;
					this.allocatiionWorkOrderService.app_forWorkOrder(res.response.id)
						.subscribe(
							(allocRes: any) => {
								this.checkWorkOrderAllocations = allocRes.response || [];
								this.checkWorkOrderLoading = false;
								this.showCheckWorkOrderModal = true;
							},
							(err) => {
								this.checkWorkOrderLoading = false;
								console.log(err);
								notify("Something Went Wrong!", "Error", 5000);
							}
						);
				},
				(err) => {
					this.checkWorkOrderLoading = false;
					console.log(err);
					notify("Something Went Wrong!", "Error", 5000);
				}
			);
	}

	onDeviceSelectChange() {
		console.log("Selection changed: ", this.selectedDevice.label);
		// this.selectedDevice = this.scanner.device!;
	}

	onImageSelected(event: Event) {
		const input = event.target as HTMLInputElement;
		if (input.files && input.files.length > 0) {
			this.capturedImageFile = input.files[0];
			const reader = new FileReader();
			reader.onload = (e) => {
				this.capturedImagePreview = e.target?.result as string;
			};
			reader.readAsDataURL(this.capturedImageFile);
		}
	}

	onPinBackspace(): void {
		if (this.supervisorPin.length === 0) return;
		this.supervisorPin = this.supervisorPin.slice(0, -1);
		this.pinError = "";
	}

	onPinDigit(digit: string): void {
		if (this.supervisorPin.length >= this.maxPinLength) return;
		this.supervisorPin += digit;
		this.pinError = "";
	}

	onPinOk(): void {
		if (this.canSubmitPin() && !this.isLoading) this.submitCloseSupervisorRequestLogin();
	}

	onScanSuccess(result: string) {
		console.log(result);
		this.scannedResult = result;
		this.getWo(result);
		this.toggleScan();
	}

	openChangeOrder() {
		this.showChangeOrderModal = true;
		this.showPopup = true;
	}

	openCheckWorkOrder() {
		this.checkWorkOrderDetails = null;
		this.checkWorkOrderAllocations = [];
		this.showCheckWorkOrderScan = true;
		this.showPopup = true;
	}

	openImageCapture() {
		this.showImagePrompt = false;
		this.showImageCapture = true;
	}

	openMachineRequestModal() {
		this.showPopup = true;
		this.showOpenMachineRequestForm = true;
	}

	openSupervisorRequest() {
		this.showPopup = true;
		this.showOpenSupervisorRequestForm = true;
	}

	pauseWorkOrder() {
		this.workOrderStageService.app_togglePause(this.availableStages[0].id)
			.subscribe(
				() => {
					notify("Stage Paused due to incomplete quantity", "success", 5000);
					this.reloadPage();
				},
				(err) => {
					notify("Something went wrong!", "error", 5000);
					console.log(err);
				}
			);
	}

	promptForImage(log: FirewallLog) {
		this.pendingLog = log;
		this.capturedImageFile = null;
		this.capturedImagePreview = "";
		this.showNok = false;
		this.showImagePrompt = true;
		this.showPopup = true;
	}

	reloadPage() {
		this.isLoading = true;
		this.showPopup = true;
		this.getInterface();
		setTimeout(() => {
			this.isLoading = false;
			this.showPopup = false;
		}, 2000);
	}

	renderStatusColor() {
		return GetProductionStatusColor(this.currentStatus);
	}

	renderStatusColorForModal(id: number) {
		return GetProductionStatusColorByNumber(id);
	}

	setCurrentOrder(id: number, type: number) {
		this.showChangeOrderModal = false;
		this.showPopup = false;

		// if there are no orders in the list, we cannot select the current one
		if (this.ordersToday.length < 1) {
			return;
		}

		const filteredOrders = this.ordersToday.filter(o => o.id == id && o.type == type);

		if (filteredOrders.length > 0) {
			this.orderCurrent = filteredOrders[0];
		}
		else
		{
			this.orderCurrent = this.ordersToday[0];
		}						
							
		console.log("Current");
		console.log(this.orderCurrent);

		this.appSettingsService.set("profileId", this.orderCurrent.operatorId);
		this.profileId = this.orderCurrent.operatorId;

		if (this.orderCurrent.allocationId > 0) {
			this.getAllocation();
		}
	}

	setToPicked() {
		switch (this.orderCurrent.orderType) {
			case 0: // EDI Order			
				if (this.quantityComplete != this.orderCurrent.quantityOrdered) {
					if (window.confirm("Quantity Complete does not match the amount ordered, are you sure you want to proceed?") == false) { return; }
				}
				this.ediOrderService.app_SetAsPicked(this.orderCurrent.id)
					.subscribe(
						() => {
							notify("Firewall Complete!", "success", 5000);
							setTimeout(() => {
								this.getInterface();
							}, 2000);
						},
						(err) => {
							console.log(err);
							notify("Something went wrong!", "error", 5000);
						},
					);
				break;
			case 10: // Work Order
				this.workOrderService.app_FirewallSetAsPicked(this.orderCurrent.id)
					.subscribe(
						() => {
							notify("Firewall Complete!", "success", 5000);
							setTimeout(() => {
								this.getInterface();
							}, 2000);
						},
						(err) => {
							console.log(err);
							notify("Something went wrong!", "error", 5000);
						},
					);
				break;
		}
	}

	skipImageUpload() {
		if (!this.pendingLog) return;
		const log = this.pendingLog;
		this.pendingLog = null;
		this.capturedImageFile = null;
		this.capturedImagePreview = "";
		this.showImageCapture = false;
		this.showImagePrompt = false;
		this.submitFirewallLogService(log);
	}

	submitArea() {
		console.log(this.selectedArea);
	}

	submitCloseSupervisorRequest() {
		this.machineService.app_CloseSupervisorRequest(this.closeSupervisorRequestDto)
			.subscribe(
				() => {
					this.showCloseSupervisorRequestForm = false;
					this.reloadPage();
				},
				(err) => {
					notify("Something went wrong!", "error", 5000);
					console.log(err);
				}
			);
	}

	submitCloseSupervisorRequestLogin() {
		this.isLoading = true;
		this.authService.app_getSupervisorIdByCode(this.supervisorPin)
			.subscribe(
				(res: any) => {
					this.isLoading = false;
					this.closeSupervisorRequestDto.supervisorId = res.response;
					this.supervisorPin = "";
					this.pinError = "";
					this.showCloseSupervisorRequestFormLogin = false;
					this.showCloseSupervisorRequestForm = true;
				},
				(err) => {
					this.isLoading = false;
					this.supervisorPin = "";
					this.pinError = "Invalid PIN. Please try again.";
					console.log(err);
				}
			);
	}

	submitCompleted() {
		const firewall = true;
		this.toggleComplete();
		this.isLoading = true;
		this.showPopup = true;

		this.quantityEntered = this.quantityEntered + this.quantityNok;

		this.workOrderStageService.completedQuantityApiKey(this.availableStages[0].id, this.quantityEntered - this.quantityComplete)
			.subscribe(
				() => {
					notify("Part Complete Submitted Successfully!", "success", 5000);
					if (firewall) {
						this.showFirewall = false;
						this.showNok = false;
						if ((this.quantityComplete + this.quantityNok) != this.quantityRequired) {
							//Pause Work Order.
							this.pauseWorkOrder();
						}
						if (this.quantityNok > 0) {
							this.increaseScrap();
						}
					}
					this.reloadPage();
				},
				(err) => {
					notify("Something went wrong!", "error", 5000);
					console.log(err);
				}
			);
	}

	submitFirewall() {
		// Snapshot before closing the form – ngModel bindings reset when *ngIf removes the form
		this.firewallOkCount = Number(this.quantityEntered);
		this.firewallNokCount = Number(this.quantityNok);
		this.quantityEntered = 0;
		this.quantityNok = 0;
		this.showFirewall = false;

		if (this.firewallNokCount > 0) {
			this.selectedArea = "";
			this.selectedReason = undefined;
			this.selectedProduction = false;
			this.selectedPaint = false;
			this.showNok = true;
		} else {
			const log = new FirewallLog();
			log.numberOfPartsChecked = this.firewallOkCount + this.firewallNokCount;
			log.numberOfPartsFailed = this.firewallNokCount;
			log.operatorId = this.profileId;
			log.partId = this.orderCurrent.partId;
			log.clientId = this.orderCurrent.clientId;
			log.allocationId = this.orderCurrent.allocationId;
			log.projectId = this.orderCurrent.part.projectId;
			this.promptForImage(log);
		}
	}

	submitFirewallLog() {
		const log = new FirewallLog();
		log.areaOfIssue = this.selectedArea;
		log.failureReasonId = this.selectedReason;
		log.numberOfPartsChecked = this.firewallOkCount + this.firewallNokCount;
		log.numberOfPartsFailed = this.firewallNokCount;
		log.numberOfPartsReworkable = 0;
		log.isProduction = this.selectedProduction;
		log.prePaint = this.selectedPaint;
		log.asnNumber = "";
		log.operatorId = this.profileId;
		log.partId = this.orderCurrent.partId;
		log.clientId = this.orderCurrent.clientId;
		log.allocationId = this.orderCurrent.allocationId;
		log.projectId = this.orderCurrent.part.projectId;

		this.promptForImage(log);
	}

	submitFirewallLogService(log: any) {
		this.firewallLogService.appCreateFirewallLog(log)
			.subscribe(
				() => {
					this.totalNok += this.firewallNokCount;
					this.totalOk += this.firewallOkCount;
					this.showPopup = false;
					this.showNok = false;
					this.showFirewall = false;
					this.getInterface();
				},
				(err) => {
					notify("Something went wrong!", "error", 5000);
					console.log(err);
				}
			);
	}

	submitIsProduction() {
		console.log(this.selectedProduction);
	}

	submitMachineRequest() {
		this.machineService.app_OpenMachineRequestForStage(this.stageId, this.selectedMachineRequestType)
			.subscribe(
				() => {
					notify("Request Submitted Successfully!", "success", 10000);
					this.showOpenMachineRequestForm = false;
					this.showPopup = false;
				},
				(err) => {
					notify("Something went wrong!", "error", 5000);
					console.log(err);
				}
			);
		this.getInterface();
	}

	submitPaint() {
		console.log(this.selectedPaint);
	}

	submitProductionMode(prodStatus: ProductionStatus) {
		console.log("Mode Change");
		console.log(this.machine.id);
		this.machineService.app_updateProductionStatus(this.machineId, prodStatus)
			.subscribe(
				() => {
					notify("Production Mode Changed Successfully!", "success", 5000);
					this.reloadPage();
				},
				(err) => {
					notify("Something went wrong!", "error", 5000);
					console.log(err);
				}
			);
	}

	submitReason() {
		console.log(this.selectedReason);
	}

	submitSupervisorRequest() {
		this.machineService.app_requestSupervisor(this.machineId, this.selectedSupervisorRequestReasonId)
			.subscribe(
				() => {
					notify("Request Submitted Successfully!", "success", 5000);
					this.showOpenSupervisorRequestForm = false;
					this.reloadPage();
				},
				(err) => {
					notify("Something went wrong!", "error", 5000);
					console.log(err);
				}
			);
		this.getInterface();
	}

	/* Toggles */
	toggleAll() {
		this.showFirewall = false;
		this.showAllocate = false;
		this.isImageModalOpen = false;
		this.showMode = false;
		this.showPopup = false;
		this.showCheckWorkOrderScan = false;
		this.showCheckWorkOrderModal = false;
	}

	toggleAllocate() {
		this.allocationWo = "";
		this.allocationQty = 0;
		this.showAllocate = !this.showAllocate;
		// this.showFirewall = !this.showFirewall;
		this.showPopup = !this.showPopup;
	}

	toggleComplete() {
		this.showFirewall = !this.showFirewall;
		this.showPopup = !this.showPopup;
	}

	toggleImage() {
		this.isImageModalOpen = !this.isImageModalOpen;
		this.showPopup = !this.showPopup;
	}

	toggleMode() {
		this.showMode = !this.showMode;
		this.showPopup = !this.showPopup;
	}

	toggleScan() {
		this.showScan = !this.showScan;
	}

	toggleSupervisor() {
		this.showSupervisor = !this.showSupervisor;
		this.showPopup = !this.showPopup;
	}

	updateNokQuantity() {
		this.quantityNok = this.quantityRequired - this.quantityEntered;
	}

	uploadFirewallImage() {
		if (!this.capturedImageFile || !this.pendingLog) return;
		const containerName = "firewall-logs";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", this.capturedImageFile);
		uploadData.append("mimeTypeKey", "ImageMimeTypes");
		this.isLoading = true;
		this.fileService.app_upload(uploadData)
			.subscribe(
				(res: any) => {
					this.isLoading = false;
					const imageUrl = `${environment.server.storageUrl}/${containerName}/${res.response[0].location}`;
					const log = this.pendingLog!;
					log.imageUrl = imageUrl;
					this.pendingLog = null;
					this.capturedImageFile = null;
					this.capturedImagePreview = "";
					this.showImageCapture = false;
					this.showImagePrompt = false;
					this.submitFirewallLogService(log);
				},
				(err) => {
					this.isLoading = false;
					console.log(err);
					notify("Image upload failed!", "error", 5000);
				}
			);
	}

	windowWidthCheck() {
		return window.innerWidth >= 768;
	}
}